export default __webpack_public_path__ + "static/media/crypto-3.59a5a36a.PNG";